<template>
  <div class="bell-area">
    <div class="notice-bell">
      <NotifierBadge :badge-count="unreadCount" class="badge" />
      <BasicLink :href="linkUrl">
        <FontAwesomeIcon :icon="['far', 'bell']" :style="styles" />
      </BasicLink>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters } = createNamespacedHelpers('notice');

import BasicLink from '@v2/atoms/BasicLink.vue';
import NotifierBadge from '@v2/atoms/NotifierBadge.vue';
export default {
  components: {
    BasicLink,
    NotifierBadge,
  },
  data() {
    return {
      linkUrl: '/u/notices',
      // prettier-ignore
      styles: {
        'position': 'absolute',
        'top': '20%',
        'left': '25%',
        'font-size': '30px',
      },
    };
  },
  computed: {
    ...mapGetters(['timelinesCount', 'newsTimelinesCount']),
    unreadCount() {
      return this.timelinesCount + this.newsTimelinesCount;
    },
  },
  async created() {
    const url = window.location.href;
    if (!url.match(/(\/u\/notices#\/(clinic|news)?$)/)) {
      this.getPageData();
    }
  },
  methods: {
    ...mapActions(['clearAllList', 'getAllList']),
    async getPageData() {
      this.clearAllList();
      await this.getAllList({ page: 0 });
    },
  },
};
</script>

<style lang="sass" scoped>

.bell-area
  position: absolute
  top: 0
  width: 100%
  height: 60px
  max-width: 750px

.notice-bell
  text-align: center
  position: absolute
  top: 5px
  right: 5px
  width: 30px
  height: 30px
  z-index: 300
  cursor: pointer
  padding: 0 10px 20px
  opacity: 1
  &:hover
    color: $palette-blue-scooter
</style>
